<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="公司名称">
            <Input v-model="form.name"></Input>
          </FormItem>
          <FormItem label="帐号">
            <Input v-model="form.cardNo"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="md-add" @click="handleCreate">上传流水</Button>
          <Button type="primary" icon="md-add" @click="handleMultiCustomCreate">多人流水上传</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <uploadBill ref="uploadBillRef" @handle-search="handleSearch"></uploadBill>
    <uploadBillMultiCom ref="uploadBillMultiCustomRef" @handle-search="handleSearch"></uploadBillMultiCom>
    <zhixiReport ref="zhixiReportRef" @handle-search="handleSearch"></zhixiReport>
  </div>
</template>

<script>
import uploadBill from './upload-bill.vue'
import uploadBillMultiCom from './upload-bill-multi-com.vue'
import zhixiReport from './zhixi-report'
import { getIds, getToken } from '@/libs/util'

export default {
  name: 'cominfo-list',
  components: {
    uploadBill, zhixiReport, uploadBillMultiCom
  },
  data () {
    return {
      columns: [
        { title: '公司名称', key: 'name' },
        { title: '公司账号', key: 'cardNo' },
        { title: '第一次', key: 'firstTime' },
        { title: '最近一次', key: 'lastTime' },
        { title: '总支出', key: 'payMoney' },
        { title: '总收入', key: 'incoming' },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('span', params.row.status === 2 ? '处理中' : (params.row.status === 200 ? '处理完成' : '处理失败'))
          }
        },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          button: [
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-construct'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleDetail(params.row)
                  }
                }
              }, '分析报告')
            },
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-attach'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.refreshType(params.row)
                  }
                }
              }, '刷新')
            },
            (h, params, vm) => {
              if (params.row.status === 200) {
                return h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon: 'md-construct'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.ShareReport(params.row)
                    }
                  },
                  ref: 'copyButton'
                }, '分享')
              }
            }
          ]
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleDetail (param) {
      this.$refs.zhixiReportRef.openModel('detail', param)
    },
    refreshType (param) {
      this.G('custominfoltd/refreshType/' + param.id).then(data => {
        this.$Message.info(data)
      })
    },
    ShareReport: function (param) {
      this.G('custominfoltd/getReport/' + param.id + '/web?token=' + getToken()).then(data => {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(data)
            .then(() => {
              this.$Message.success('成功复制到剪贴板！')
            }, (err) => {
              console.error('复制失败', err)
              this.$Message.error('复制到剪贴板失败，请重试！')
            })
        } else {
          const textArea = document.createElement('textarea')
          textArea.value = data
          textArea.style.position = 'absolute'
          textArea.style.opacity = '0'
          textArea.style.left = '-999999px'
          textArea.style.top = '-999999px'
          document.body.appendChild(textArea)
          textArea.focus()
          textArea.select()
          if (!document.execCommand('copy')) {
            this.$Message.error('复制到剪贴板失败，请重试！')
          } else {
            this.$Message.success('成功复制到剪贴板！')
          }
          textArea.remove()
        }

        /* else {
            const textArea = document.createElement('textarea')
            textArea.value = JSON.stringify(geometries)
            // 使text area不在viewport，同时设置不可见
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            new Promise((resolve, reject) => {
              // 执行复制命令并移除文本框
              document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
              textArea.remove()
            }).then(
              () => {
                this.$Message.success('成功复制到剪贴板！')
              },
              () => {
                this.$Message.error('复制到剪贴板失败，请重试！')
              }
            )
          } */
      }
      )
    },
    handleCreate () {
      this.$refs.uploadBillRef.openModel('create')
    },
    handleMultiCustomCreate () {
      this.$refs.uploadBillMultiCustomRef.openModel('create')
    },
    handleDelete () {
      this.D('custominfo', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    handleUpdate () {

    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map,
        sort: 'MDF_TIME'
      }
      this.L('custominfoltd', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
